import { equals, find } from 'ramda';

import { type TGeoValue } from '../api-models/common/json_query';

import { setGeo } from './helpers';
import { type TJsonQuery } from './types';

export function removeGeo(jsonQuery: TJsonQuery): (geoValue: TGeoValue) => TJsonQuery {
  return geoValue => {
    if (!jsonQuery.geo || !jsonQuery.geo.value || !find(equals(geoValue), jsonQuery.geo.value)) {
      return jsonQuery;
    }

    return setGeo()(jsonQuery)(jsonQuery.geo.value.filter(value => !equals(value, geoValue)));
  };
}
